var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21V7.125H7.125V3H16.875V11.25H21V21H13.325V16.875H10.675V21H3ZM4.5 19.5H7.125V16.875H4.5V19.5ZM4.5 15.375H7.125V12.75H4.5V15.375ZM4.5 11.25H7.125V8.625H4.5V11.25ZM8.625 15.375H11.25V12.75H8.625V15.375ZM8.625 11.25H11.25V8.625H8.625V11.25ZM8.625 7.125H11.25V4.5H8.625V7.125ZM12.75 15.375H15.375V12.75H12.75V15.375ZM12.75 11.25H15.375V8.625H12.75V11.25ZM12.75 7.125H15.375V4.5H12.75V7.125ZM16.875 19.5H19.5V16.875H16.875V19.5ZM16.875 15.375H19.5V12.75H16.875V15.375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.cb63e215b67917c9e54b747b4c4d74aa.svg";
export { ForwardRef as ReactComponent };